/**
 * Created by moon on 2018/1/15.
 */
import Vue from 'vue'
import VeeValidate, {
  Validator
} from 'vee-validate';
import zh_CN from 'vee-validate/dist/locale/zh_CN.js';
const config = {
  // events: 'blur',
  locale: 'zh_CN',
};
Validator.localize('zh_CN', zh_CN);
Vue.use(VeeValidate, config);


//自定义的校验规则
Validator.extend('mobile', {
  getMessage: field => "请输入正确手机号",
  validate: value => value.length == 11
});
// password:8-20位,只能包括英文字母、数字和特殊字符
Validator.extend('password', {
  getMessage: field => "6-20位,只能包括英文字母、数字和特殊字符",
  validate: value => /^[A-Za-z0-9#@!~%^&_*]{6,20}$/.test(value)
});
Validator.extend('syskey', {
  getMessage: field => "1-100位,除中文之外的所有字符",
  validate: value => /^[^\u4E00-\u9FA5]{1,100}$/.test(value)
});
Validator.extend('channel', {
  getMessage: field => "4位,字母、数字、下划线",
  validate: value => /^[A-Za-z0-9_]{4}$/.test(value)
});
// password:8-20位,必须同时包含数字、字母、特殊字符
// Validator.extend('password', {
//   getMessage: field => "8-20位,必须同时包含数字、字母、特殊字符",
//   validate: value => /^(?=.*[A-z])(?=.*\d)(?=.*[#@!~%^&*_])[A-z\d#@!~%^&_*]{8,20}$/.test(value)
// });
//2-30位,中文,字母,数字,下划线,括号,中划线
Validator.extend('name', {
  getMessage: field => "2-30位,中文,字母,数字,下划线,括号,中划线",
  validate: value => /^[\u4E00-\u9FA5\uF900-\uFA2DA-Za-z0-9_（）\(\)\-\s]{2,30}$/.test(value)
});
//1-20位中文
Validator.extend('normal-name', {
  getMessage: field => "1-20位中文、英文或数字字符",
  validate: value => /^[\u4E00-\u9FA5\uF900-\uFA2DA-Za-z0-9]{1,20}$/.test(value)
});
//1-20位英文字符
Validator.extend('name-en', {
  getMessage: field => "1-20位英文或数字字符",
  validate: value => /^[A-Za-z0-9]{1,20}$/.test(value)
});
//1-2位数字
Validator.extend('num1-2', {
  getMessage: field => "1-2位数字",
  validate: value => /^[1-9]\d?$/.test(value)
});
//机构，菜单名称
Validator.extend('menu-name', {
  getMessage: field => "2-30中文、数字、字母和冒号",
  validate: value => /^[\u4E00-\u9FA5\uF900-\uFA2DA-Za-z0-9:]{2,30}$/.test(value)
});
//2-30数字、字母和冒号
Validator.extend('zh2-30', {
  getMessage: field => "2-30数字、字母和冒号",
  validate: value => /^[A-Za-z0-9:]{2,30}$/.test(value)
});
// 1位大写字母
Validator.extend('tag', {
  getMessage: field => "1位大写字母",
  validate: value => /^[A-Z]{1}$/.test(value)
});
//16位字母、数字
Validator.extend('token', {
  getMessage: field => "16位字母、数字",
  validate: value => /^[0-9a-zA-Z]{16}$/.test(value)
});
Validator.extend('sn', {
  getMessage: field => "30位以内字母、数字",
  validate: value => /^[0-9a-zA-Z]{1,30}$/.test(value)
});
Validator.extend('endSn', {
  getMessage: field => "30位以内字母、数字",
  validate: value => /^[0-9a-zA-Z]{0,30}$/.test(value)
});
//IP地址
Validator.extend('ipAddress', {
  getMessage: field => "格式错误",
  validate: value => /^(((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5]))|((?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)))$/.test(value)
})
//端口
Validator.extend('port', {
  getMessage: field => "端口格式，如8080",
  validate: value => /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/.test(value)
})
//4-20位,只能包括中文字,字母,数字和下划线
Validator.extend('loginName', {
  getMessage: field => "4-20位,只能包括中文字,字母,数字和下划线",
  validate: value => /^[\u4E00-\u9FA5\uF900-\uFA2D\w]{4,20}$/.test(value)
})
Validator.extend('mobile', {
  getMessage: field => "号码格式错误",
  validate: value => /^1[34578]\d{9}$/.test(value)
})
Validator.extend('tel', {
  getMessage: field => "号码格式错误",
  validate: value => /^0\d{2,3}-?\d{7,8}$/.test(value)
})
Validator.extend('phone', {
  getMessage: field => "号码格式错误", // \-
  validate: value => /^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$|(^1[3|4|5|7|8][0-9]{9}$)/.test(value)
  // validate: value => /(^[0-9]{3,4}\-[0-9]{3,8}$)|(^[0-9]{3,8}$)|(^\([0-9]{3,4}\)[0-9]{3,8}$)|(^0{0,1}1[34578][0-9]{9}$)/.test(value)
})
Validator.extend('money', {
  getMessage: field => "整数或仅包含两位小数", // \-
  validate: value => /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/.test(value)
  // validate: value => /(^[0-9]{3,4}\-[0-9]{3,8}$)|(^[0-9]{3,8}$)|(^\([0-9]{3,4}\)[0-9]{3,8}$)|(^0{0,1}1[34578][0-9]{9}$)/.test(value)
})

//修改默认错误提示
const dict = {
  zh_CN: {
    messages: {
      required: (field) => "请填写！"
    }
  }
};

Validator.localize(dict);
// Validator.locale('zh_CN', zh_CN);

Vue.use(VeeValidate);



// WEBPACK FOOTER //
// ./src/components/common/Validate.js